import {MarketerBounds, MarketerAPIDataSource} from '../api/MarketerAPIDataSource';
import {Marketer} from '../models/marketer.model';
import {mapMarketerDTOToModel} from '../mappers/marketer.mapper';
import {MapService} from '../../../Services/map/MapService';

export class GetMarketersInBoundsUseCase {
  constructor (
    private mapService: MapService
  ) {}

  async execute (
    bounds: MarketerBounds,
    includeDetails: boolean = false,
    role: string = 'market_developer',
    onlyActive: boolean = true,
    limit: number = 50
  ): Promise<Marketer[]> {
    try {

      // جلب البيانات من API
      const response = await MarketerAPIDataSource.getNearbyInBounds(
        bounds,
        includeDetails,
        role,
        onlyActive,
        limit
      );

      if (!response.items || !Array.isArray(response.items)) {
        return [];
      }

      // تحويل البيانات وتصفيتها
      const transformedMarketers = this.transformAndFilterMarketers(response.items, bounds);

      return transformedMarketers;

    } catch (error) {
      throw new Error(`Failed to get marketers in bounds: ${error instanceof Error ? error.message : 'Unknown error'}`);
    }
  }

  private transformAndFilterMarketers (marketersData: any[], bounds: MarketerBounds): Marketer[] {
    const validMarketers: Marketer[] = [];

    for (const marketerDto of marketersData) {
      try {
        // تحويل البيانات باستخدام mapper
        const transformedMarketer = mapMarketerDTOToModel(marketerDto);

        // التحقق من صحة الإحداثيات
        if (!this.validateMarketerCoordinates(transformedMarketer)) {
          continue;
        }

        // إضافة map aliases للتوافق مع react-map-gl
        const marketerWithAliases = this.addMapAliases(transformedMarketer);

        // تصفية حسب المنطقة المحددة (إذا لم يكن API يدعم البحث الجغرافي بدقة)
        if (this.isMarketerInBounds(marketerWithAliases, bounds)) {
          validMarketers.push(marketerWithAliases);
        }

      } catch (error) {
        continue;
      }
    }

    return validMarketers;
  }

  private validateMarketerCoordinates (marketer: Marketer): boolean {
    return (
      marketer.latitude !== undefined &&
      marketer.longitude !== undefined &&
      !isNaN(marketer.latitude) &&
      !isNaN(marketer.longitude) &&
      marketer.latitude >= -90 &&
      marketer.latitude <= 90 &&
      marketer.longitude >= -180 &&
      marketer.longitude <= 180
    );
  }

  private addMapAliases (marketer: Marketer): Marketer & { lat: number; lng: number } {
    return {
      ...marketer,
      lat: marketer.latitude,
      lng: marketer.longitude
    };
  }

  private isMarketerInBounds (marketer: Marketer, bounds: MarketerBounds): boolean {
    return this.mapService.isPointInBounds(
      {lat: marketer.latitude, lng: marketer.longitude},
      {
        sw: {lat: bounds.sw.lat, lng: bounds.sw.lng},
        ne: {lat: bounds.ne.lat, lng: bounds.ne.lng}
      }
    );
  }
}
